module.exports = __webpack_public_path__ + "assets/img/returnBtn-d83aafcb.png";